function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.41425 5.99976L11.7072 1.70676C12.0982 1.31576 12.0982 0.683762 11.7072 0.292762C11.3162 -0.0982383 10.6842 -0.0982383 10.2933 0.292762L6.00025 4.58576L1.70725 0.292762C1.31625 -0.0982383 0.68425 -0.0982383 0.29325 0.292762C-0.09775 0.683762 -0.09775 1.31576 0.29325 1.70676L4.58625 5.99976L0.29325 10.2928C-0.09775 10.6838 -0.09775 11.3158 0.29325 11.7068C0.48825 11.9018 0.74425 11.9998 1.00025 11.9998C1.25625 11.9998 1.51225 11.9018 1.70725 11.7068L6.00025 7.41376L10.2933 11.7068C10.4882 11.9018 10.7443 11.9998 11.0002 11.9998C11.2562 11.9998 11.5122 11.9018 11.7072 11.7068C12.0982 11.3158 12.0982 10.6838 11.7072 10.2928L7.41425 5.99976Z",
  fill: "#353F50"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b1ca0a5d.svg";
export { ForwardRef as ReactComponent };